export default __webpack_public_path__ + "static/media/dreadvenom.d748ad98.png";